export enum DocumentType {
  APPROVED = 'APPROVED',
  DISAPPROVED = 'DISAPPROVED',
  PENDING = 'PENDING',
  NOT_STARTED = 'NOT_STARTED',
}

export interface DocumentStatus {
  type: DocumentType;
  label: string;
}

export interface Document {
  active: boolean;
  documentConfigId: number;
  id?: number;
  mediaId?: number;
  mediaVcode?: string;
  name: string;
  reason?: string;
  required: boolean;
  status: DocumentStatus;
  updatedAt?: Date;
  uploaded: boolean;
  payment?: string;
  proposalOrderPaymentId?: number;
  hasPriorityApproval: boolean;
  temporaryUrl?: string;
}

export interface DateFilterHandles {
  getInputInfo: () => string;
  closeFilter: () => void;
  resetFilter: () => void;
}

export interface Option {
  label: string;
  value: string;
}

export interface SubGroup {
  id: string;
  title: string;
}

export interface GroupOption extends Option {
  subGroup: SubGroup;
}

export interface FilterGroup {
  groupId: string;
  options: Option[] | GroupOption[];
  title: string;
  type: 'checkbox' | 'checkbox-group' | 'radio';
  hideClearButton?: boolean;
}

interface DefaultFormat {
  id: string;
  values: string[];
}

export interface CustomPayload {
  formattedSearchParams?: string;
  formattedValues?: DefaultFormat[];
}

export interface FormatOptionsParams<T> {
  items: T[];
  getLabel: (item: T) => string;
  getValue: (item: T) => string;
}
export interface FormattedDealer<T> {
  state: string;
  dealers: T[];
}
